import Vue from 'vue'
import axios from 'axios'
import { baseURL } from '../config'
// 获取订单列表
export const getOrderList = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 订单-删除 
export const delOrder = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 订单-支付界面数据预览 
export const orderPayPreview = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 订单-支付 
export const orderPay = data => Vue.prototype.getAxios(baseURL + "/index.php", data)



